/**
 * The prefix for API authentication routes
 * Routes that start with this prefix are used for API authentication purposes
 * @type {string}
 */
export const apiAuthPrefix: string = "/api/auth";

/**
 * If you change any of these routes, make sure to update `app/[locale]/`
 */
export const ROUTES = {
    HOME: "/",
    PROFILE: "/profile",
    LOGIN: "/login",
    VERIFY_EMAIL: "/verify-email",
    FORGOT_PASSWORD: "/forgot-password",
    SETTINGS: "/profile/settings",
    RESET_PASSWORD: "/reset-password",
    INVOICE_FOLDERS: "/invoice-folders",
    LEGAL: {
        PRIVACY_POLICY: "/legal/privacy-policy",
        TERMS_OF_SERVICE: "/legal/terms",
    },
    EXPENSE: {
        EDIT: "/expense/[id]/edit",
    },
    SESSION: `${ apiAuthPrefix }/session`,
    DASHBOARD: {
        HOME: "/dashboard",
        STATISTICS: "/dashboard/statistics",
        ACTIVITY_LOGS: "/dashboard/activity-logs",
        MANAGE_USERS: "/dashboard/manage-users",
        CONFIG_FORM: "/dashboard/config-form",
        EXPORT_DATA: "/dashboard/export-data",
    },
};

/**
 * The default route for logging in
 * @type {string}
 */
export const DEFAULT_LOGIN_URL: string = ROUTES.LOGIN;

/**
 * The default redirect path for logging in
 * @type {string}
 */
export const DEFAULT_LOGIN_REDIRECT: string = ROUTES.HOME;

/**
 * An array of routes that are accessible to everyone
 * These routes do not require authentication
 * @type {string[]}
 */
export const publicRoutes: string[] = [
    ROUTES.HOME,
    ROUTES.PROFILE,
    ROUTES.LEGAL.PRIVACY_POLICY,
    ROUTES.LEGAL.TERMS_OF_SERVICE,
];

/**
 * An array of routes that are used for authentication
 * These routes will redirect logged in users
 * @type {string[]}
 */
export const authRoutes: string[] = [
    DEFAULT_LOGIN_URL,
    ROUTES.VERIFY_EMAIL,
    ROUTES.FORGOT_PASSWORD,
    ROUTES.RESET_PASSWORD,
];